import React from "react";
import CustomModal from "../../../../globals/components/Modal";
import { useDispatch } from "react-redux";
import { setobligationRejectmodalVisible } from "../../myContract.Slice";
import CustomButton from "../../../../globals/components/button";
import { Form, Input } from "antd";
import "./obgview.less";
import { getAcceptorrejectobligation } from "../../myContract.Action";
const Rejectobligationmodal = (props) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const {
    intl: { formatMessage },
    myContract,
    
  } = props;
  const { isobligationrejectmodalVisible, obligationrejectmodalRecord,isacceptorrejectedLoading,contractDetails={} } =
    myContract;
  const modelClose = async () => {
    dispatch(setobligationRejectmodalVisible({ visible: false, record: {} }));
  };
  return (
    <CustomModal
      width={400}
      centered
      maskClosable={false}
      title={formatMessage({ id: "add_rejection_comment" })}
      placement="right"
      onCancel={() => {
        modelClose();
      }}
      className={"reject-modal"}
      open={isobligationrejectmodalVisible}
      footer={
        <div>
          <CustomButton
           
            onClick={() => {
              modelClose();
            }}
          >
            {formatMessage({ id: "cancel" })}
          </CustomButton>
          <CustomButton
             type="danger"
             loading={isacceptorrejectedLoading}
             disabled={isacceptorrejectedLoading}
            onClick={async() => {
               await form.validateFields()
              const commentvalue = form.getFieldValue("rejectioncomment");
              if (commentvalue) {
                const { data, obgpageSubobligationData } =
                  obligationrejectmodalRecord;
               const rejectionComment = commentvalue || "";
                dispatch(
                  getAcceptorrejectobligation({
                    data:{...data,rejectionComment},
                    obgpageSubobligationData,
                    contractId: contractDetails?._id,
                  })
                ).then(()=>{

                form.resetFields()
                })
              }
            }}
          >
            {formatMessage({ id: "reject" })}
          </CustomButton>
        </div>
      }
    >
      <Form form={form}>
        <Form.Item  rules={[
                  {
                    required: true,
                    message: formatMessage({ id: "please_add_reject_comment" }),
                  },
                  {
                    whitespace: true,
                    message: formatMessage({ id: "please_add_reject_comment_empty" }),

                  },
                ]} name="rejectioncomment">
          <Input.TextArea placeholder="Enter comment" rows={4} />
        </Form.Item>
      </Form>
    </CustomModal>
  );
};

export default Rejectobligationmodal;
